<template>
    <div class="thankyouPage">
        <p>Nezapomeňte o svém projektu říct známým a kamarádům, abyste získali co nejvíce hlasů a zvýšili svou šanci
            vyhrát.</p>
    </div>
</template>

<script>
    export default {
        name: 'TrophyChallengeRegistrationSuccess',
        mounted() {
            document.querySelector('.registration-info-container').style.display = 'none';
            document.querySelector('.thank-you-container').style.display = 'block';
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/trophy-challenge/RegistrationSuccess.vue